import {
  CarregarPermissoes,
  ValidarPermissao,
} from '@/modules/system/auth/application/auth.service';
import { NavigationView } from '@/shared/constants/navigation-view.enum';
import { isVisaoAdministrador } from '@/shared/constants/visao-sistema.constants';
import { PermissionEnum } from '@/modules/system/auth/domain/enums/permission.enum';
import { RoleEnum } from '@/modules/system/auth/domain/enums/role.enum';
import type { RoleLevelDto } from '@/modules/system/auth/domain/role-level.dto';

/** Suporte administrativo ao módulo de relatórios (visão Administrador ou ADMIN_ACTIONS). */
export function usuarioTemSuporteAdministrativoRelatorios(
  authVisao: NavigationView | null | undefined,
  permissoes: RoleLevelDto[] = CarregarPermissoes(),
): boolean {
  if (isVisaoAdministrador(authVisao)) return true;
  return ValidarPermissao(permissoes, [
    { role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ },
  ]);
}
